class ColorSwatch extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.swatches = this.querySelectorAll(".color-swatcher");
    this.cardImg = this.querySelector(".card__img:not(.card__img--hover)");
    this.cardHoverImg = this.querySelector(".card__img--hover");
    this.cardPicture = this.querySelector(".card__picture");
    
    // Store original image data
    if (this.cardImg && this.cardPicture) {
      this.originalSrc = this.cardPicture.dataset.originalSrc || this.cardImg.src;
      this.originalSrcset = this.cardImg.srcset || "";
    }
    
    this.setupEvents();
    this.setupProductCardHover();
  }

  setupEvents() {
    this.swatches.forEach(swatch => {
      // Mouse enter - change to specific variant color image
      swatch.addEventListener("mouseenter", (e) => {
        const swatchColor = e.target.dataset.color;
        const variantImg = e.target.dataset.img;
        const variantHoverImg = e.target.dataset.hover;
        const variantSrcset = e.target.dataset.srcset;
        
        // Change main image to the variant color image (first image of the variant)
        if (variantImg && this.cardImg) {
          this.cardImg.src = variantImg;
          this.cardImg.srcset = variantSrcset || "";
        }
        
        // Set up hover image for this variant (second image of the variant)
        if (this.cardHoverImg && variantHoverImg) {
          this.cardHoverImg.src = variantHoverImg;
        }
      });
      
      // Mouse leave - revert to original
      swatch.addEventListener("mouseleave", () => {
        this.revertToOriginal();
      });
      
      // Single click - change image (permanent until another swatch is clicked)
      // Double click - navigate to variant URL
      let clickCount = 0;
      swatch.addEventListener("click", (e) => {
        clickCount++;
        
        if (clickCount === 1) {
          // Single click - change image and keep it
          const swatchColor = e.target.dataset.color;
          const variantImg = e.target.dataset.img;
          const variantHoverImg = e.target.dataset.hover;
          const variantSrcset = e.target.dataset.srcset;
          const variantId = e.target.dataset.variantId || e.target.getAttribute('data-variant-id');
          
          if (variantImg && this.cardImg) {
            this.cardImg.src = variantImg;
            this.cardImg.srcset = variantSrcset || "";
            // Store as new "current" image
            this.cardPicture.dataset.currentSrc = variantImg;
            this.cardPicture.dataset.currentSrcset = variantSrcset || "";
            
            // Set up hover image for the selected variant
            if (this.cardHoverImg && variantHoverImg) {
              this.cardHoverImg.src = variantHoverImg;
            }
          }
          
          // CRITICAL FIX: Update the form input with the correct variant ID
          if (variantId) {
            // Try multiple possible containers to find the form
            let formInput = null;
            
            // Method 1: Look in closest color-swatch container
            const colorSwatchContainer = e.target.closest('color-swatch');
            if (colorSwatchContainer) {
              formInput = colorSwatchContainer.querySelector('input[name="id"]');
            }
            
            // Method 2: If not found, try closest card container  
            if (!formInput) {
              const cardContainer = e.target.closest('.card__container');
              if (cardContainer) {
                formInput = cardContainer.querySelector('input[name="id"]');
              }
            }
            
            // Method 3: If still not found, try looking in the whole collection item
            if (!formInput) {
              const collectionItem = e.target.closest('.collection__grid__item');
              if (collectionItem) {
                formInput = collectionItem.querySelector('input[name="id"]');
              }
            }
            
            if (formInput) {
              formInput.value = variantId;
              console.log('✅ Successfully updated variant ID in form:', variantId, 'Element:', formInput);
            } else {
              console.error('❌ Could not find form input to update variant ID');
            }
          }
          
          // Wait for potential double click
          setTimeout(() => {
            clickCount = 0;
          }, 300);
        } else if (clickCount === 2) {
          // Double click - navigate to variant URL
          const variantUrl = e.target.dataset.href;
          if (variantUrl) {
            window.location.href = variantUrl;
          }
          clickCount = 0;
        }
      });
      
      // Show tooltip
      swatch.addEventListener("mouseenter", (e) => {
        const tooltip = swatch.parentElement.querySelector(".color-swatcher--tooltip");
        if (tooltip) {
          tooltip.classList.remove("hidden");
        }
      });
      
      swatch.addEventListener("mouseleave", (e) => {
        const tooltip = swatch.parentElement.querySelector(".color-swatcher--tooltip");
        if (tooltip) {
          tooltip.classList.add("hidden");
        }
      });
    });
  }
  
  setupProductCardHover() {
    // Only hover on the actual image area, not text or white space
    const cardPicture = this.querySelector('.card__picture');
    if (cardPicture && this.cardHoverImg) {
      // Show hover image only when hovering over the image area
      cardPicture.addEventListener('mouseenter', () => {
        if (this.cardHoverImg) {
          this.cardHoverImg.style.opacity = '1';
        }
      });
      
      // Hide hover image when leaving image area (but not when hovering swatches)
      cardPicture.addEventListener('mouseleave', (e) => {
        // Only hide if not hovering over swatches
        const swatchContainer = this.querySelector('.card__color-swatcher--container');
        if (!swatchContainer || !swatchContainer.contains(e.relatedTarget)) {
          if (this.cardHoverImg) {
            this.cardHoverImg.style.opacity = '0';
          }
          this.revertToOriginal();
        }
      });
    }
  }
  
  revertToOriginal() {
    if (this.cardImg) {
      // Check if there's a "current" image set by single click
      const currentSrc = this.cardPicture?.dataset.currentSrc;
      const currentSrcset = this.cardPicture?.dataset.currentSrcset;
      
      if (currentSrc) {
        // Use the image set by single click
        this.cardImg.src = currentSrc;
        this.cardImg.srcset = currentSrcset || "";
      } else if (this.originalSrc) {
        // Fall back to original image
        this.cardImg.src = this.originalSrc;
        this.cardImg.srcset = this.originalSrcset;
      }
    }
  }
}

customElements.define("color-swatch", ColorSwatch);

// Additional initialization for collection pages
document.addEventListener("DOMContentLoaded", function() {
  // Store original image sources
  document.querySelectorAll(".card__img:not(.card__img--hover)").forEach(img => {
    img.dataset.originalSrc = img.src;
  });
  
  // Initialize color swatches that might not have been caught by custom element
  document.querySelectorAll("color-swatch").forEach(element => {
    if (!element.initialized) {
      element.initialized = true;
      // Force re-init if needed
    }
  });
});
